import { dev } from "$app/environment";
export const write_intro = () => {
  const art: string = `
-----------------------------------------------------------------------------
hello inspector, welcome to
 _____            __ _  ______            _      _   _         _ _           
/  __ \\          / _| | | ___ \\          | |    | | | |       | (_)          
| /  \\/_ __ __ _| |_| |_| |_/ /___  _   _| | ___| |_| |_ ___  | |___   _____ 
| |   | '__/ _\` |  _| __|    // _ \\| | | | |/ _ \\ __| __/ _ \\ | | \\ \\ / / _ \\
| \\__/\\ | | (_| | | | |_| |\\ \\ (_) | |_| | |  __/ |_| ||  __/_| | |\\ V /  __/
 \\____/_|  \\__,_|_|  \\__\\_| \\_\\___/ \\__,_|_|\\___|\\__|\\__\\___(_)_|_| \\_/ \\___|

this website was designed and built by Stephen Gunn
and is powered by SvelteKit && Directus.io
please use /contact if you want to get in touch
-----------------------------------------------------------------------------
`;
  if (!dev)
    console.log(
      "%c" + art,
      "white-space: pre;  display: block; word-break: keep-all;",
    );
};
